module.exports = __webpack_public_path__ + "static/media/LandingExploreCompanies.e8cbdf14.png";